<template>
   <div class="mant-page" :class="{ 'mant-page--recovery': enRecuperacion }">

      <!-- ══════════════════════════════════════
           PANTALLA DE MANTENIMIENTO
      ══════════════════════════════════════ -->
      <template v-if="!enRecuperacion">
         <!-- ── Engranajes de fondo ── -->
         <div class="mant-gears">
            <svg class="gear gear-1" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
               <path d="M487.4 315.7l-42.6-24.6c4.3-23.2 4.3-47 0-70.2l42.6-24.6c4.9-2.8 7.1-8.6 5.5-14-11.1-35.6-30-67.8-54.7-94.6-3.8-4.1-10-5.1-14.8-2.3L380.8 110c-17.9-15.4-38.5-27.3-60.8-35.1V25.8c0-5.6-3.9-10.5-9.4-11.7-36.7-8.2-74.3-7.8-109.2 0-5.5 1.2-9.4 6.1-9.4 11.7V75c-22.2 7.9-42.8 19.8-60.8 35.1L88.7 85.5c-4.9-2.8-11-1.9-14.8 2.3-24.7 26.7-43.6 58.9-54.7 94.6-1.7 5.4.6 11.2 5.5 14L67.3 221c-4.3 23.2-4.3 47 0 70.2l-42.6 24.6c-4.9 2.8-7.1 8.6-5.5 14 11.1 35.6 30 67.8 54.7 94.6 3.8 4.1 10 5.1 14.8 2.3l42.6-24.6c17.9 15.4 38.5 27.3 60.8 35.1v49.2c0 5.6 3.9 10.5 9.4 11.7 36.7 8.2 74.3 7.8 109.2 0 5.5-1.2 9.4-6.1 9.4-11.7v-49.2c22.2-7.9 42.8-19.8 60.8-35.1l42.6 24.6c4.9 2.8 11 1.9 14.8-2.3 24.7-26.7 43.6-58.9 54.7-94.6 1.5-5.5-.7-11.3-5.6-14.1zM256 336c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"/>
            </svg>
            <svg class="gear gear-2" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
               <path d="M487.4 315.7l-42.6-24.6c4.3-23.2 4.3-47 0-70.2l42.6-24.6c4.9-2.8 7.1-8.6 5.5-14-11.1-35.6-30-67.8-54.7-94.6-3.8-4.1-10-5.1-14.8-2.3L380.8 110c-17.9-15.4-38.5-27.3-60.8-35.1V25.8c0-5.6-3.9-10.5-9.4-11.7-36.7-8.2-74.3-7.8-109.2 0-5.5 1.2-9.4 6.1-9.4 11.7V75c-22.2 7.9-42.8 19.8-60.8 35.1L88.7 85.5c-4.9-2.8-11-1.9-14.8 2.3-24.7 26.7-43.6 58.9-54.7 94.6-1.7 5.4.6 11.2 5.5 14L67.3 221c-4.3 23.2-4.3 47 0 70.2l-42.6 24.6c-4.9 2.8-7.1 8.6-5.5 14 11.1 35.6 30 67.8 54.7 94.6 3.8 4.1 10 5.1 14.8 2.3l42.6-24.6c17.9 15.4 38.5 27.3 60.8 35.1v49.2c0 5.6 3.9 10.5 9.4 11.7 36.7 8.2 74.3 7.8 109.2 0 5.5-1.2 9.4-6.1 9.4-11.7v-49.2c22.2-7.9 42.8-19.8 60.8-35.1l42.6 24.6c4.9 2.8 11 1.9 14.8-2.3 24.7-26.7 43.6-58.9 54.7-94.6 1.5-5.5-.7-11.3-5.6-14.1zM256 336c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"/>
            </svg>
            <svg class="gear gear-3" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
               <path d="M487.4 315.7l-42.6-24.6c4.3-23.2 4.3-47 0-70.2l42.6-24.6c4.9-2.8 7.1-8.6 5.5-14-11.1-35.6-30-67.8-54.7-94.6-3.8-4.1-10-5.1-14.8-2.3L380.8 110c-17.9-15.4-38.5-27.3-60.8-35.1V25.8c0-5.6-3.9-10.5-9.4-11.7-36.7-8.2-74.3-7.8-109.2 0-5.5 1.2-9.4 6.1-9.4 11.7V75c-22.2 7.9-42.8 19.8-60.8 35.1L88.7 85.5c-4.9-2.8-11-1.9-14.8 2.3-24.7 26.7-43.6 58.9-54.7 94.6-1.7 5.4.6 11.2 5.5 14L67.3 221c-4.3 23.2-4.3 47 0 70.2l-42.6 24.6c-4.9 2.8-7.1 8.6-5.5 14 11.1 35.6 30 67.8 54.7 94.6 3.8 4.1 10 5.1 14.8 2.3l42.6-24.6c17.9 15.4 38.5 27.3 60.8 35.1v49.2c0 5.6 3.9 10.5 9.4 11.7 36.7 8.2 74.3 7.8 109.2 0 5.5-1.2 9.4-6.1 9.4-11.7v-49.2c22.2-7.9 42.8-19.8 60.8-35.1l42.6 24.6c4.9 2.8 11 1.9 14.8-2.3 24.7-26.7 43.6-58.9 54.7-94.6 1.5-5.5-.7-11.3-5.6-14.1zM256 336c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"/>
            </svg>
            <svg class="gear gear-4" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
               <path d="M487.4 315.7l-42.6-24.6c4.3-23.2 4.3-47 0-70.2l42.6-24.6c4.9-2.8 7.1-8.6 5.5-14-11.1-35.6-30-67.8-54.7-94.6-3.8-4.1-10-5.1-14.8-2.3L380.8 110c-17.9-15.4-38.5-27.3-60.8-35.1V25.8c0-5.6-3.9-10.5-9.4-11.7-36.7-8.2-74.3-7.8-109.2 0-5.5 1.2-9.4 6.1-9.4 11.7V75c-22.2 7.9-42.8 19.8-60.8 35.1L88.7 85.5c-4.9-2.8-11-1.9-14.8 2.3-24.7 26.7-43.6 58.9-54.7 94.6-1.7 5.4.6 11.2 5.5 14L67.3 221c-4.3 23.2-4.3 47 0 70.2l-42.6 24.6c-4.9 2.8-7.1 8.6-5.5 14 11.1 35.6 30 67.8 54.7 94.6 3.8 4.1 10 5.1 14.8 2.3l42.6-24.6c17.9 15.4 38.5 27.3 60.8 35.1v49.2c0 5.6 3.9 10.5 9.4 11.7 36.7 8.2 74.3 7.8 109.2 0 5.5-1.2 9.4-6.1 9.4-11.7v-49.2c22.2-7.9 42.8-19.8 60.8-35.1l42.6 24.6c4.9 2.8 11 1.9 14.8-2.3 24.7-26.7 43.6-58.9 54.7-94.6 1.5-5.5-.7-11.3-5.6-14.1zM256 336c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"/>
            </svg>
            <svg class="gear gear-5" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
               <path d="M487.4 315.7l-42.6-24.6c4.3-23.2 4.3-47 0-70.2l42.6-24.6c4.9-2.8 7.1-8.6 5.5-14-11.1-35.6-30-67.8-54.7-94.6-3.8-4.1-10-5.1-14.8-2.3L380.8 110c-17.9-15.4-38.5-27.3-60.8-35.1V25.8c0-5.6-3.9-10.5-9.4-11.7-36.7-8.2-74.3-7.8-109.2 0-5.5 1.2-9.4 6.1-9.4 11.7V75c-22.2 7.9-42.8 19.8-60.8 35.1L88.7 85.5c-4.9-2.8-11-1.9-14.8 2.3-24.7 26.7-43.6 58.9-54.7 94.6-1.7 5.4.6 11.2 5.5 14L67.3 221c-4.3 23.2-4.3 47 0 70.2l-42.6 24.6c-4.9 2.8-7.1 8.6-5.5 14 11.1 35.6 30 67.8 54.7 94.6 3.8 4.1 10 5.1 14.8 2.3l42.6-24.6c17.9 15.4 38.5 27.3 60.8 35.1v49.2c0 5.6 3.9 10.5 9.4 11.7 36.7 8.2 74.3 7.8 109.2 0 5.5-1.2 9.4-6.1 9.4-11.7v-49.2c22.2-7.9 42.8-19.8 60.8-35.1l42.6 24.6c4.9 2.8 11 1.9 14.8-2.3 24.7-26.7 43.6-58.9 54.7-94.6 1.5-5.5-.7-11.3-5.6-14.1zM256 336c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"/>
            </svg>
            <svg class="gear gear-6" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
               <path d="M487.4 315.7l-42.6-24.6c4.3-23.2 4.3-47 0-70.2l42.6-24.6c4.9-2.8 7.1-8.6 5.5-14-11.1-35.6-30-67.8-54.7-94.6-3.8-4.1-10-5.1-14.8-2.3L380.8 110c-17.9-15.4-38.5-27.3-60.8-35.1V25.8c0-5.6-3.9-10.5-9.4-11.7-36.7-8.2-74.3-7.8-109.2 0-5.5 1.2-9.4 6.1-9.4 11.7V75c-22.2 7.9-42.8 19.8-60.8 35.1L88.7 85.5c-4.9-2.8-11-1.9-14.8 2.3-24.7 26.7-43.6 58.9-54.7 94.6-1.7 5.4.6 11.2 5.5 14L67.3 221c-4.3 23.2-4.3 47 0 70.2l-42.6 24.6c-4.9 2.8-7.1 8.6-5.5 14 11.1 35.6 30 67.8 54.7 94.6 3.8 4.1 10 5.1 14.8 2.3l42.6-24.6c17.9 15.4 38.5 27.3 60.8 35.1v49.2c0 5.6 3.9 10.5 9.4 11.7 36.7 8.2 74.3 7.8 109.2 0 5.5-1.2 9.4-6.1 9.4-11.7v-49.2c22.2-7.9 42.8-19.8 60.8-35.1l42.6 24.6c4.9 2.8 11 1.9 14.8-2.3 24.7-26.7 43.6-58.9 54.7-94.6 1.5-5.5-.7-11.3-5.6-14.1zM256 336c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"/>
            </svg>
         </div>

         <div class="mant-content">
            <div class="mant-cross-wrapper">
               <div class="mant-cross-ring mant-ring-1"></div>
               <div class="mant-cross-ring mant-ring-2"></div>
               <img src="/assets/logo-u700.png" class="mant-logo" alt="UNICAES" />
            </div>

            <h1 class="mant-title">Sistema en Mantenimiento</h1>
            <p class="mant-subtitle">UNICAES · Colecturía Digital<template v-if="sedeNombre"> · {{ sedeNombre }}</template></p>
            <div class="mant-divider"></div>

            <div class="mant-cards">
               <div class="mant-card mant-fade-in" style="animation-delay: 0.2s">
                  <div class="mant-card-label">
                     <v-icon small class="mr-1" color="#deab2f">fa-id-card</v-icon>
                     Carnet del estudiante
                  </div>
                  <div class="mant-card-value mant-carnet">{{ carnet || '—' }}</div>
               </div>
               <div class="mant-card mant-fade-in" style="animation-delay: 0.4s">
                  <div class="mant-card-label">
                     <v-icon small class="mr-1" color="#deab2f">fa-tools</v-icon>
                     Mantenimiento activado
                  </div>
                  <div class="mant-card-value">{{ desde || 'No disponible' }}</div>
               </div>
               <div class="mant-card mant-fade-in" style="animation-delay: 0.6s">
                  <div class="mant-card-label">
                     <v-icon small class="mr-1" color="#deab2f">fa-clock</v-icon>
                     Hora actual
                  </div>
                  <div class="mant-card-value mant-clock">{{ horaActual }}</div>
               </div>
            </div>

            <p class="mant-msg">
               Estamos trabajando para mejorar el sistema.<br/>
               Por favor, intenta nuevamente más tarde.
            </p>
         </div>

      </template>

      <!-- ══════════════════════════════════════
           PANTALLA DE RECUPERACIÓN
      ══════════════════════════════════════ -->
      <template v-else>
         <!-- Halo de fondo -->
         <div class="rec-bg-halo" :style="haloStyle"></div>

         <div class="rec-content">

            <!-- Ícono con progreso circular -->
            <div class="rec-icon-area">
               <svg class="rec-circle-svg" viewBox="0 0 120 120">
                  <circle cx="60" cy="60" r="54" class="rec-circle-track"/>
                  <circle cx="60" cy="60" r="54" class="rec-circle-fill"
                     :style="{ strokeDashoffset: circleOffset }"/>
               </svg>
               <span class="rec-circle-seconds">{{ segundosRestantes }}</span>
            </div>

            <!-- Textos -->
            <h1 class="rec-title">¡Sistema Restaurado!</h1>
            <p class="rec-msg">
               Hemos levantado el mantenimiento.<br/>
               Redirigiendo a Colecturía Digital…
            </p>

            <!-- Barra lineal -->
            <div class="rec-bar-track">
               <div class="rec-bar-fill" :style="{ width: progreso + '%' }"></div>
            </div>
            <p class="rec-bar-label">{{ Math.round(progreso) }}% completado</p>

         </div>
      </template>

   </div>
</template>

<script>
import axios from 'axios'

const DURACION_RECOVERY = 5000
const INTERVALO_POLL    = 4000

export default {
   name: 'Mantenimiento',
   data: () => ({
      horaActual:        '',
      horaHandle:        null,
      pollHandle:        null,
      enRecuperacion:    false,
      progreso:          0,
      segundosRestantes: 5,
      progresoHandle:    null
   }),
   computed: {
      carnet()     { return this.$route.query.carnet     || '' },
      desde()      { return this.$route.query.desde      || '' },
      accesscode() { return this.$route.query.accesscode || '' },
      from()       { return this.$route.query.from       || 'colecturiaDigital' },

      sedeNombre() {
         const sede = process.env.VUE_APP_SEDE
         if (sede === 'IL') return 'Sede Ilobasco'
         if (sede === 'SA') return 'Sede Santa Ana'
         return ''
      },

      intensidad() { return this.progreso / 100 },

      // Offset para el círculo SVG (circunferencia = 2π × 54 ≈ 339.3)
      circleOffset() {
         const circ = 2 * Math.PI * 54
         return circ - (circ * this.progreso / 100)
      },

      haloStyle() {
         const b = this.intensidad
         return {
            opacity: 0.15 + b * 0.25,
            transform: `scale(${1 + b * 0.5})`
         }
      }
   },
   mounted() {
      this.actualizarHora()
      this.horaHandle = setInterval(this.actualizarHora, 1000)
      this.pollHandle = setInterval(this.verificarEstado, INTERVALO_POLL)
   },
   beforeDestroy() {
      clearInterval(this.horaHandle)
      clearInterval(this.pollHandle)
      clearInterval(this.progresoHandle)
   },
   methods: {
      actualizarHora() {
         this.horaActual = new Date().toLocaleString('es-SV', {
            dateStyle: 'full',
            timeStyle: 'medium'
         })
      },

      verificarEstado() {
         axios.get('api/Configuracion/pagosEnLinea')
            .then((response) => {
               if (response.data.valor === 'true') this.iniciarRecuperacion()
            })
            .catch(() => {})
      },

      iniciarRecuperacion() {
         clearInterval(this.pollHandle)
         this.pollHandle        = null
         this.enRecuperacion    = true
         this.progreso          = 0
         this.segundosRestantes = 5

         const inicio = performance.now()
         this.progresoHandle = setInterval(() => {
            const elapsed = performance.now() - inicio
            this.progreso          = Math.min((elapsed / DURACION_RECOVERY) * 100, 100)
            this.segundosRestantes = Math.max(0, Math.ceil((DURACION_RECOVERY - elapsed) / 1000))

            if (elapsed >= DURACION_RECOVERY) {
               clearInterval(this.progresoHandle)
               const query = this.from === 'colecturiaExterna'
                  ? {}
                  : { carnet: this.carnet, accesscode: this.accesscode }
               this.$router.push({ name: this.from, query })
            }
         }, 50)
      },

   }
}
</script>

<style scoped>
/* ── Base ── */
.mant-page {
   position: fixed; inset: 0; z-index: 999;
    background: linear-gradient(135deg, #6b0101 0%, #A00402 45%, #7a0301 100%);
   display: flex; align-items: center; justify-content: center;
   overflow: hidden; font-family: 'Roboto', sans-serif;
   transition: background 1.2s ease;
}
.mant-page--recovery {
   background: linear-gradient(160deg, #1a0202 0%, #3d0101 50%, #1a0202 100%);
}

/* ── Engranajes de fondo ── */
.mant-gears { position: absolute; inset: 0; pointer-events: none; overflow: hidden; }
.gear { position: absolute; fill: rgba(222,171,47,0.09); }
.gear-1 { width: 260px; height: 260px; bottom: -80px; left: -80px;  animation: spinCW  22s linear infinite; }
.gear-2 { width: 160px; height: 160px; top:   -50px;  right: -50px; animation: spinCCW 14s linear infinite; }
.gear-3 { width:  90px; height:  90px; top:    60px;  left:   80px; animation: spinCW   9s linear infinite; }
.gear-4 { width: 200px; height: 200px; top:    30%;   right: -70px; animation: spinCCW 18s linear infinite; }
.gear-5 { width:  80px; height:  80px; bottom: 60px;  right: 120px; animation: spinCW   7s linear infinite; }
.gear-6 { width: 130px; height: 130px; bottom: -30px; left:    42%; animation: spinCCW 12s linear infinite; }
@keyframes spinCW  { to { transform: rotate(360deg);  } }
@keyframes spinCCW { to { transform: rotate(-360deg); } }

/* ── Mantenimiento: contenido ── */
.mant-content {
   position: relative; z-index: 2; text-align: center;
   padding: 40px 24px; max-width: 700px; width: 100%;
   animation: fadeInDown 0.7s ease;
}
@keyframes fadeInDown {
   from { opacity: 0; transform: translateY(-30px); }
   to   { opacity: 1; transform: translateY(0); }
}
.mant-cross-wrapper {
   position: relative; display: inline-flex;
   align-items: center; justify-content: center;
   margin-bottom: 28px; width: 120px; height: 120px;
}
.mant-cross-ring {
   position: absolute; border-radius: 50%;
   border: 2px solid rgba(222,171,47,0.4);
   animation: pulseRing 2.4s ease-out infinite;
}
.mant-ring-1 { width: 100px; height: 100px; animation-delay: 0s; }
.mant-ring-2 { width: 120px; height: 120px; animation-delay: 0.8s; }
@keyframes pulseRing {
   0%   { transform: scale(0.85); opacity: 0.8; }
   70%  { transform: scale(1.15); opacity: 0; }
   100% { transform: scale(1.15); opacity: 0; }
}
.mant-logo {
   width: 150px; height: 150px; object-fit: contain;
   position: relative; z-index: 1;
   animation: glowLogo 2.4s ease-in-out infinite;
}
@keyframes glowLogo {
   0%,100% { filter: drop-shadow(0 0 6px rgba(255,255,255,0.4)); }
   50%     { filter: drop-shadow(0 0 22px rgba(255,255,255,0.9)); }
}
.mant-title {
   color: #fff; font-size: clamp(24px,5vw,38px); font-weight: 700;
   letter-spacing: 2px; text-shadow: 0 2px 12px rgba(0,0,0,0.4);
   margin: 0 0 6px; text-transform: uppercase;
}
.mant-subtitle {
   color: #deab2f; font-size: 15px; letter-spacing: 4px;
   text-transform: uppercase; margin: 0 0 20px;
}
.mant-divider {
   width: 60px; height: 3px; margin: 0 auto 28px;
   background: linear-gradient(90deg, transparent, #deab2f, transparent);
}
.mant-cards {
   display: flex; flex-wrap: wrap; gap: 16px;
   justify-content: center; margin-bottom: 28px;
}
.mant-card {
   background: rgba(255,255,255,0.08);
   border: 1px solid rgba(222,171,47,0.25);
   border-radius: 12px; padding: 16px 24px;
   min-width: 200px; backdrop-filter: blur(6px);
}
.mant-card-label {
   color: rgba(255,255,255,0.6); font-size: 12px;
   text-transform: uppercase; letter-spacing: 1px;
   margin-bottom: 8px; display: flex; align-items: center;
}
.mant-card-value { color: #fff; font-size: 16px; font-weight: 500; }
.mant-carnet     { font-size: 22px; font-weight: 700; letter-spacing: 3px; color: #deab2f; }
.mant-clock      { font-size: 13px; line-height: 1.5; }
.mant-msg        { color: rgba(255,255,255,0.55); font-size: 14px; line-height: 1.7; margin: 0; }
.mant-fade-in    { opacity: 0; animation: fadeInUp 0.6s ease forwards; }
@keyframes fadeInUp {
   from { opacity: 0; transform: translateY(20px); }
   to   { opacity: 1; transform: translateY(0); }
}

/* ── Recuperación ── */
.rec-bg-halo {
   position: absolute; inset: 0; pointer-events: none;
   background: radial-gradient(ellipse 60% 50% at 50% 50%, rgba(222,171,47,0.18), transparent 70%);
   transition: opacity 0.4s ease, transform 0.4s ease;
}

.rec-content {
   position: relative; z-index: 2; text-align: center;
   padding: 40px 24px; max-width: 480px; width: 100%;
   animation: fadeInDown 0.5s ease;
}

/* círculo de progreso */
.rec-icon-area {
   position: relative; display: inline-flex;
   align-items: center; justify-content: center;
   margin-bottom: 20px;
}
.rec-circle-svg {
   width: 120px; height: 120px;
   transform: rotate(-90deg);
}
.rec-circle-track {
   fill: none; stroke: rgba(255,255,255,0.08); stroke-width: 6;
}
.rec-circle-fill {
   fill: none;
   stroke: #deab2f;
   stroke-width: 6;
   stroke-linecap: round;
   stroke-dasharray: 339.3;
   transition: stroke-dashoffset 0.1s linear;
   filter: drop-shadow(0 0 4px rgba(222,171,47,0.6));
}
.rec-bolt-icon {
   position: absolute;
}

/* segundos dentro del círculo */
.rec-circle-seconds {
   position: absolute;
   font-size: 42px; font-weight: 700;
   color: #fff; line-height: 1;
   font-variant-numeric: tabular-nums;
   text-shadow: 0 0 20px rgba(222,171,47,0.5);
}

/* textos */
.rec-title {
   color: #deab2f; font-size: clamp(20px,4vw,30px);
   font-weight: 700; letter-spacing: 1px;
   text-transform: uppercase; margin: 0 0 10px;
}
.rec-msg {
   color: rgba(255,255,255,0.6); font-size: 14px;
   line-height: 1.8; margin: 0 0 28px;
}

/* barra lineal */
.rec-bar-track {
   height: 4px; background: rgba(255,255,255,0.12);
   border-radius: 99px; overflow: hidden;
}
.rec-bar-fill {
   height: 100%;
   background: linear-gradient(90deg, #A00402, #deab2f);
   border-radius: 99px;
   transition: width 0.05s linear;
   box-shadow: 0 0 8px rgba(222,171,47,0.5);
}
.rec-bar-label {
   color: rgba(255,255,255,0.35); font-size: 12px;
   margin: 8px 0 0; letter-spacing: 1px;
}
</style>
